import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable()
export class DataSharingService {
  public isAuthenticated: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public messageSubject = new Subject<string>();

  constructor() { }

  public setData(message: string) {
    this.messageSubject.next(message);
  }

  public getData(): Observable<string> {
    return this.messageSubject.asObservable();
  }
}
